import React, {
    useState,
    useEffect,
} from 'react';
import { connect } from "react-redux";
import { Dialog, DialogTitle, Button, DialogContent, FormControlLabel, Checkbox, DialogActions } from '@material-ui/core';

import {
    deploy_device_in_past_date, reset_device_operation_response as reset_device_operation_response_action
} from 'actions/user';
import { reset_new_patient_response as reset_new_patient_response__action } from 'actions/patients';

import icon_checkbox_grey_outline from "assets/images/icon-checkbox-grey-outline.svg";
import icon_checkbox_grey from "assets/images/icon-checkbox-grey.svg";
import IntlMessages from 'util/IntlMessages';

const PastDateAllocationDevice = props => {
    const [marked, setMarked] = useState(false);

    useEffect(() => {
        if (props.isOpen) {
            setMarked(false);
        }
    }, [props.isOpen]);

    return (<Dialog
        className="custom-popup extend-device-popup scrollable-popup"
        PaperProps={{ classes: { root: 'custom-popup-root' } }}
        open={!!props.isOpen}
        onClose={props.onCancel}
        disableBackdropClick={true}
    >
        <div className="popup-wrap">
            <div className="popup-header">
                <DialogTitle className="popup-title"><IntlMessages id="popup.pastDateMsg"></IntlMessages></DialogTitle>
                <div className="popup-header-right">
                    <Button className="popup-close" disableRipple={true} disableFocusRipple={true} onClick={props.onCancel}><i className="zmdi zmdi-close zmdi-hc-fw"></i></Button>
                </div>
            </div>
            <DialogContent className="popup-content">
                {props.deployError && (
                    <div className="field-group">
                        {props.deployError}
                        {/* You are trying to deploy a device to this patient in a past date, this action might fail. However, you can request admin to do so. */}
                    </div>
                )}
                <div className="field-group data-group">
                    <div>
                        <div className="field-block data-block">
                            <label className="field-label"><IntlMessages id="mypatients.deviceId"></IntlMessages>:</label>
                            <strong>{props.deviceId}</strong>
                        </div>
                        {
                            !props.deviceId
                            && (
                                <div className="error-msg"><IntlMessages id="popup.deviceSelect"></IntlMessages></div>
                            )
                        }
                    </div>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <div>
                        <div className="field-block data-block">
                            <label className="field-label"><IntlMessages id="mypatients.patientId"></IntlMessages>:</label>
                            <strong>{props.patientCode}</strong>
                        </div>
                        {
                            !props.patientCode
                            && (
                                <div className="error-msg"><IntlMessages id="popup.selectPatient"></IntlMessages>.</div>
                            )
                        }
                    </div>
                </div>
                <div className="field-group full-field-group">
                    <div className="field-block data-block">
                        <label className="field-label"><IntlMessages id="newpatient.deviceAllocation"></IntlMessages>:</label>
                        <strong>{props.allocationDate}</strong>
                    </div>
                </div>
                <div className="field-group full-field-group">
                    <div className="field-block data-block">
                        <label className="field-label"><IntlMessages id="newpatient.deviceReturn"></IntlMessages>:</label>
                        <strong>{props.deallocationDate}</strong>
                    </div>
                </div>
                {props.deployError && (
                    <div className="field-group full-field-group">
                        <div className="field-block">
                            <FormControlLabel
                                className="checkbox-group"
                                control={
                                    <Checkbox
                                        className="custom-checkbox"
                                        checked={marked}
                                        disableRipple={true}
                                        icon={<img src={icon_checkbox_grey_outline} alt="Icon" />}
                                        checkedIcon={<img src={icon_checkbox_grey} alt="Icon" />}
                                        onChange={(event) => {
                                            setMarked(event.target.checked);
                                        }}
                                    />
                                }
                                label="Request admin to deploy the device to this patient on the mentioned dates."
                                classes={{
                                    label: 'custom-checkbox-label'
                                }}
                            />
                        </div>
                    </div>
                )}
            </DialogContent>
            <DialogActions className="popup-footer">
                <Button className="secondary-button" disableRipple={true} disableFocusRipple={true} onClick={props.onCancel} ><IntlMessages id="main.cancel"></IntlMessages></Button>
                {!props.deployError ? (
                    <Button
                        className={"primary-button " + ((!props.deviceId || !props.patientCode) ? "disabled-field" : "")}
                        disabled={!props.deviceId || !props.patientCode}
                        disableRipple={true}
                        disableFocusRipple={true}
                        onClick={props.deployDevice}
                    >Confirm</Button>
                ) : (
                    <Button
                        className={"primary-button " + ((!props.deviceId || !props.patientCode || !marked) ? "disabled-field" : "")}
                        disabled={!props.deviceId || !props.patientCode || !marked}
                        disableRipple={true}
                        disableFocusRipple={true}
                        onClick={() => {
                            props.deploy_device_in_past_date({
                                patient_id: props.patientId,
                                patient_code: props.patientCode,
                                device_id: props.deviceId,
                                allocation_date: props.allocationDate,
                                deallocation_date: props.deallocationDate,
                                page: props.page,
                            });
                            props.reset_device_operation_response();
                            props.reset_new_patient_response();
                            props.onCancel();
                        }}
                    > <IntlMessages id="popup.sendRequest"></IntlMessages></Button>
                )}
            </DialogActions>
        </div>
    </Dialog>)
}

const mapStateToProps = (state) => {
    return {
        user: { ...state.user },
    }
};
const mapDispatchToProps = dispatch => {
    return {
        deploy_device_in_past_date: (payload) => dispatch(deploy_device_in_past_date(payload)),
        reset_new_patient_response: () => dispatch(reset_new_patient_response__action()),
        reset_device_operation_response: () => dispatch(reset_device_operation_response_action())

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PastDateAllocationDevice);
